import store from './store';
import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken, removeToken, removeStation, getStation } from '@/utils/auth' 

NProgress.configure({ showSpinner: false })

const whiteList = ['/login']
const stationWhiteList = ['/login', '/stationlist', '/photovoltaic/dashboard', '/hydro/dashboard']

router.beforeEach((to, from, next) => {
  NProgress.start() 
  const username = getToken();
  let station = getStation();
  station = station ? JSON.parse(station) : ''
  if (username) {
    /* has token*/

    //ws对象不存在并且为水电系统或者全系统时，则初始化socket连接
    if(!window.WS && station && ['hy', 'all'].indexOf(process.env.MODULE) > -1){
      socketInit(username, station.id)
    }
    if(!store.getters.isLoadRoute){
      store.dispatch('getMenu').then(res => {
        //socket连接
        const routes = generateRoutes(res);
        const Layout = r => require.ensure([], () => r(require('@/views/layout/Layout')))
        router.addRoutes([{path: '/', component: Layout, children: routes}]);
        store.dispatch('loadRoute')
        if (to.path === '/login') {
          next({ path: '/' })
          NProgress.done() 
        } else {
          if(!station && stationWhiteList.indexOf(to.path) == -1 && username != "administratorhzinfov4"){
            next({ path: '/' })
            NProgress.done() 
          }else{
            next({ ...to })
          }
        }
      }).catch(() => {
        //session失效
        removeToken();
        removeStation();
        if(window.WS){
          try {
            WS.disconnect();
          } catch (error) {
            
          }
          
          delete window.WS;
        }
        next('/login')
        NProgress.done() 
      })
    }else{
      //如果没有选择站点，则跳转到首页
      if(!station && stationWhiteList.indexOf(to.path) == -1 && username != "administratorhzinfov4"){
        next({ path: '/' })
        NProgress.done() 
      }else if (to.path === '/login') {
        next({ path: '/' })
        NProgress.done() 
      } else {
        next()
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next('/login') // 否则全部重定向到登录页
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})


function generateRoutes(routes){
  let pageRoutes = [];

  let loadPackage = function(obj, packageName) {
      if(obj.path) {
          if(obj.redirect){
              pageRoutes.push(obj);
          }else if(obj.templateId){
              let url = process.env.NODE_ENV == "development" ? 'commons/config_page_bak.vue' : 'hydro/page_setting/config_page.vue';
              let Page = r => require.ensure([], () => r(require(`@/views/${url}`)));
              const route = { 
                  path: obj.path, 
                  component: Page, 
                  name: obj.title, 
                  meta: { icon: obj.icon, templateId: obj.templateId, noCache: true } 
              }
              pageRoutes.push(route);
          }else{
              let pathArray = obj.path.split("?");
              let path = pathArray[0]
              let isIframe = pathArray[1] && pathArray[1].indexOf("iframe") > -1
              if(isIframe){
                let Page = r => require.ensure([], () => r(require('@/views/commons/iframe.vue')));
                const route = { 
                    path: path, 
                    component: Page, 
                    name: obj.title, 
                    meta: { icon: obj.icon, href: obj.href} 
                }
                pageRoutes.push(route);
              }else{
                let Page = r => require.ensure([], () => r(require('@/views' + (obj.filePath || path) )));
                // let Page = () => import('@/views' + (obj.filePath || obj.path) );
                const route = { 
                    path: path, 
                    component: Page, 
                    name: obj.title, 
                    meta: { icon: obj.icon} 
                }
                pageRoutes.push(route);
              }
          }
      }
      if(obj.children) {
          obj.children.map(one => {
              loadPackage(one, packageName);
          });
      }
  }

  routes.map(one => {
      let packageName = one.title;
      loadPackage(one, packageName);
  })
  return pageRoutes;
}


// WEBPACK FOOTER //
// ./src/permission.js